import { styled } from '@mui/material/styles';

export const Logo = styled('img')`
    width: 60px;
    height: 60px;
`